import React from 'react';

import {Link} from '../../../../lib/routes';

import css from './commone.module.css';

type Props = {
	args: string[];
	name: string;
};

// {@feature fighter-weapon-mastery, Оружейное мастерство}
// ссылка ведёт на /classes/:classId/:featureId — classId совпадает с первым сегментом id особенности
export const FeaturePlugin: React.FC<Props> = ({args}) => {
	const [id, title] = args;
	const classId = id.split('-')[0];
	return (
		<Link route={'classFeature'} params={{id: classId, featureId: id}} title={title} className={css.yellowLink}>
			{title}
		</Link>
	);
};
